'use client';

import { Lock, Crown } from 'lucide-react';
import { Button } from './ui/button';
import { useState } from 'react';
import { PremiumUpgradeDialog } from './PremiumUpgradeDialog';

interface FeatureLockOverlayProps {
  featureName: string;
  children?: React.ReactNode;
}

export function FeatureLockOverlay({ featureName, children }: FeatureLockOverlayProps) {
  const [upgradeDialogOpen, setUpgradeDialogOpen] = useState(false);

  return (
    <>
      <div className="relative">
        <div className="absolute inset-0 bg-black/60 backdrop-blur-sm z-10 flex items-center justify-center rounded-lg">
          <div className="text-center p-6 bg-[#112240] rounded-xl border-2 border-[#FFD700] max-w-md">
            <div className="flex justify-center mb-4">
              <div className="relative">
                <Crown className="w-16 h-16 text-[#FFD700]" />
                <Lock className="w-8 h-8 text-[#FFD700] absolute -bottom-1 -right-1" />
              </div>
            </div>
            <h3 className="text-xl font-bold text-white mb-2">
              Fonctionnalité Premium
            </h3>
            <p className="text-[#a8b2d1] mb-4">
              {featureName} est réservé aux membres Premium
            </p>
            <Button
              onClick={() => setUpgradeDialogOpen(true)}
              className="bg-gradient-to-r from-[#FFD700] to-[#FFA500] text-[#0a192f] hover:opacity-90 font-semibold w-full"
            >
              <Crown className="w-4 h-4 mr-2" />
              Débloquer avec Premium
            </Button>
          </div>
        </div>
        <div className="blur-sm pointer-events-none">
          {children}
        </div>
      </div>

      <PremiumUpgradeDialog
        open={upgradeDialogOpen}
        onOpenChange={setUpgradeDialogOpen}
      />
    </>
  );
}
